export const CITIES = {
  'tel-aviv': {
    id: 'tel-aviv',
    slug: 'tel-aviv',
    name: 'Tel Aviv',
    displayName: 'Happy Hours Tel Aviv',
    shortName: 'TLV',
    country: 'IL',
    timezone: 'Asia/Jerusalem',
    defaultCenter: { lat: 32.080942, lng: 34.780719 },
    bounds: { north: 32.1333, south: 32.0504, east: 34.8180, west: 34.7276 },
    contactEmail: 'happyhourstelaviv@gmail.com',
    gridPointsFile: 'tlv_points.csv',
    tagline: 'Your Guide To The Best Deals In Tel Aviv',
    facebookUrl: 'https://www.facebook.com/happyhourstlv',
    siteUrl: 'https://www.happyhourstlv.com',
    privacyUrl: 'https://www.happyhourstlv.com/privacy.html',
    tosUrl: 'https://www.happyhourstlv.com/tos.html',
    gtmContainerId: 'GTM-MVHJNT',
    // Hostnames that map to this city (include localhost for dev)
    hostnames: ['happyhourstlv.com', 'www.happyhourstlv.com', 'happy-hours-tlv-18664.web.app', 'happyhours-tlv.web.app', 'localhost'],
    // SEO-specific fields
    seo: {
      keywords: 'happy hour tel aviv, tel aviv happy hours, drink deals tel aviv, bar specials tel aviv, cheap drinks tel aviv',
      hreflang: 'en-IL'
    }
  },
  'london': {
    id: 'london',
    slug: 'london',
    name: 'London',
    displayName: 'Happy Hours London',
    shortName: 'LDN',
    country: 'GB',
    timezone: 'Europe/London',
    defaultCenter: { lat: 51.5074, lng: -0.1278 },
    bounds: { north: 51.6723, south: 51.3849, east: 0.1482, west: -0.3514 },
    contactEmail: 'happyhourslondon@gmail.com',
    gridPointsFile: 'london_points.csv',
    tagline: 'Your Guide To The Best Deals In London',
    facebookUrl: null,
    siteUrl: 'https://www.happyhourslondon.com',
    privacyUrl: 'https://www.happyhourslondon.com/privacy.html',
    tosUrl: 'https://www.happyhourslondon.com/tos.html',
    gtmContainerId: 'GTM-PR2XSGZ4',
    hostnames: ['happyhourslondon.com', 'www.happyhourslondon.com', 'happyhours-london.web.app'],
    // SEO-specific fields
    seo: {
      keywords: 'happy hour london, london happy hours, drink deals london, pub specials london, cheap drinks london',
      hreflang: 'en-GB'
    }
  }
};

export const DEFAULT_CITY = 'tel-aviv';

export const getCityBySlug = (slug) => CITIES[slug] || CITIES[DEFAULT_CITY];

export const getAllCities = () => Object.values(CITIES);

export const isValidCitySlug = (slug) => slug in CITIES;

// Get city config by hostname
export const getCityByHostname = (hostname) => {
  for (const [slug, config] of Object.entries(CITIES)) {
    if (config.hostnames.includes(hostname)) {
      return config;
    }
  }
  return CITIES[DEFAULT_CITY]; // Fallback to Tel Aviv
};
